export const getColumns = [
    {
        title: "编码",
        dataIndex: "code",
        width: 100
    },
    {
        title: "公司全称",
        dataIndex: "name",
        width: 300
    },
    {
        title: "备注",
        dataIndex: "remark",
        width: 200
    },
    {
        title: "创建时间",
        dataIndex: "create_time",
        width: 150,
        customRender: (text: string) => text || "-"
    }
]
